<section class="immunization-wrapper general-wrapper enable-wellness">
	<div id="print_div" #print_div></div>

	<!-- Outer card wrapping banner + table -->
	<div class="imm-card">
		<!-- Travel Consultation Banner -->
		<div *ngIf="!upcomingTravelAppt" class="imm-banner">
			<div class="twc-imm-banner-body">
				<p class="twc-imm-banner-title">Book a EHE travel consultation available at any of our EHE clinics *</p>
				<a
					[routerLink]="['/scheduling/create/appointment']"
					appEheAnalytics
					[data]="{
						pageUrl: '/wellness/immunization',
						redirectedTo: '/scheduling/create/appointment',
						componentName: 'immunization',
						id: 'Schedule ehe travel consultation',
						placement: 'immunization'
					}"
					class="imm-book-btn">
					<img src="/assets/images/calendar.svg" aria-hidden="true" />
					<span [translate]="'wellness.immunization.description-link'">Book Now</span>
				</a>
				<p class="twc-imm-banner-note">
					* New York, NY; Stamford, CT; Morristown, NJ; Chicago, IL; Houston, TX; Boston, MA; and McLean, VA
				</p>
			</div>

			<img src="/assets/images/ehe_color_cross1.svg" alt="" aria-hidden="true" class="twc-imm-banner-cross" />
		</div>

		<!-- Print action -->
		<div class="tw-flex tw-justify-end tw-mb-3" *ngIf="isRecords()">
			<e-ngx-print
				#print2
				[mode]=""
				[popTitle]="' '"
				[showBtn]="false"
				[printHTML]="print_div"
				[printStyle]="printStyle"
				[printCSS]="printCSS">
			</e-ngx-print>
			<i class="fas fa-print twc-imm-print-icon" (click)="customPrint()" appEheAnalytics [data]="analyticsData"></i>
		</div>

		<div class="imm-table-wrap">
			<!-- Header row -->
			<div
				matSort
				matSortActive="date"
				matSortDirection="desc"
				matSortDisableClear
				(matSortChange)="sortData($event)"
				class="imm-header-row tw-flex tw-border-b tw-border-gray-200 tw-px-6 tw-py-4">
				<div mat-sort-header="name" class="twc-imm-th-label tw-flex-1">
					<span [translate]="'wellness.immunization.table.type'">Vaccine</span>
					<i class="fas fa-chevron-down imm-th-chevron"></i>
				</div>
				<div mat-sort-header="date" class="twc-imm-th-label tw-flex-1 tw-justify-center">
					<span [translate]="'wellness.immunization.table.date'">Date</span>
					<i class="fas fa-chevron-down imm-th-chevron"></i>
				</div>
				<span class="twc-imm-th-label tw-flex-1 tw-justify-center">
					<span [translate]="'wellness.immunization.table.source'">Source</span>
					<i class="fas fa-chevron-down imm-th-chevron"></i>
				</span>
			</div>

			<!-- No records message -->
			<div class="tw-text-center tw-py-10 tw-text-gray-400 tw-text-sm" *ngIf="!isRecords()">No records to display</div>

			{{ profile ? updateVaccinesList() : '' }}

			<!-- Data rows -->
			<ng-container *ngFor="let data of pagedData">
				<mat-accordion>
					<mat-expansion-panel [hideToggle]="true" class="imm-row-panel">
						<mat-expansion-panel-header>
							<mat-panel-description class="imm-cell imm-cell--vaccine">
								{{ data.name === getCovid19VaccineName() ? 'COVID-19 (' + data.name + ')' : data.name }}
							</mat-panel-description>
							<mat-panel-description class="imm-cell imm-cell--date">
								{{ data.date | date: 'MMMM d, y' }}
							</mat-panel-description>
							<mat-panel-description class="imm-cell imm-cell--source">
								<span>{{ data.source }}</span>
								<a
									(click)="tryDownloadVaxPassPDF()"
									class="link"
									*ngIf="covid19VaccineOptions.showPdfDownloadLink && data.name === getCovid19VaccineName()">
									<span class="tw-pl-1" [translate]="'vax-pass.card.download-pdf'">(Download PDF)</span>
								</a>
							</mat-panel-description>
						</mat-expansion-panel-header>

						<mat-expansion-panel-header
							*ngIf="covid19VaccineOptions.showQRCodesAndClearTile && data.name === getCovid19VaccineName()"
							class="save-covid-records">
							<mat-panel-description class="mat-cell covid-links">
								<div class="">
									<div class="col-md-6 third-col">
										<div class="qr-code">
											<p [translate]="'vax-pass.card.save-covid-record'">
												Save your COVID-19 vaccination record to your Apple Wallet or Google Pay.
											</p>
											<p [translate]="'vax-pass.card.scan-qr-code'">
												<b>Scan below with your phone camera.</b>
											</p>
											<div class="row qr-code-icon">
												<div *ngIf="getQRCodeUrl('APPLE')" class="col md-4 qr-code-col">
													<img [src]="getQRCodeUrl('APPLE')" alt="QRCODE" />
													<div class="apple">
														<span [translate]="'vax-pass.card.apple-users'">Apple Users</span>
													</div>
												</div>
												<div *ngIf="getQRCodeUrl('GOOGLE')" class="col md-4 qr-code-col">
													<img [src]="getQRCodeUrl('GOOGLE')" alt="QRCODE" />
													<div class="android">
														<span [translate]="'vax-pass.card.android-users'">Android Users</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-lg-1 second-col">
										<h5>OR</h5>
									</div>
									<div class="col first-col">
										<div class="clear">
											<img src="/assets/images/clear-logo.svg" alt="clear" />
											<p [translate]="'vax-pass.card.link-covid-record-to-clear'">
												Link your COVID-19 vaccination record to CLEAR Health Pass for easy entry to locations
												nationwide.
											</p>
											<button class="button" mat-button>
												<a
													href="https://clear.app.link/ehe_health"
													target="_blank"
													appGoogleAnalytics
													[eventData]="{
														eventCategory: 'Link',
														eventAction: 'Click - Link My Record',
														eventLabel: 'VaxStatus - Link My Record'
													}">
													<span [translate]="'vax-pass.card.clear-link'">Link My Record</span>
												</a>
											</button>
											<div>
												<button class="button" mat-stroked-button>
													<a
														href="https://ehe.health/clear"
														target="_blank"
														appGoogleAnalytics
														[eventData]="{
															eventCategory: 'Link',
															eventAction: 'Click - Learn more',
															eventLabel: 'VaxStatus - Learn more Clear link'
														}"
														>Learn more</a
													>
												</button>
											</div>
										</div>
									</div>
								</div>
							</mat-panel-description>
						</mat-expansion-panel-header>
					</mat-expansion-panel>
				</mat-accordion>
			</ng-container>

			<div *ngIf="isRecords() && totalPages > 1" class="imm-pagination">
				<div class="imm-pagination__controls">
					<button
						class="imm-pg-btn imm-pg-btn--nav"
						type="button"
						[disabled]="pageIndex === 0"
						(click)="goToPage(0)"
						aria-label="First page">
						<svg
							width="16"
							height="16"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							aria-hidden="true">
							<polyline points="11 18 5 12 11 6" />
							<polyline points="19 18 13 12 19 6" />
						</svg>
					</button>
					<button
						class="imm-pg-btn imm-pg-btn--nav"
						type="button"
						[disabled]="pageIndex === 0"
						(click)="prevPage()"
						aria-label="Previous page">
						<svg
							width="16"
							height="16"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							aria-hidden="true">
							<polyline points="15 18 9 12 15 6" />
						</svg>
					</button>
					<button
						*ngFor="let p of visiblePages"
						class="imm-pg-btn"
						[class.imm-pg-btn--active]="p === pageIndex"
						[class.imm-pg-btn--ellipsis]="p === 'ellipsis'"
						type="button"
						[disabled]="p === 'ellipsis'"
						(click)="p !== 'ellipsis' && goToPage(+p)">
						{{ p === 'ellipsis' ? '...' : +p + 1 }}
					</button>
					<button
						class="imm-pg-btn imm-pg-btn--nav"
						type="button"
						[disabled]="pageIndex >= totalPages - 1"
						(click)="nextPage()"
						aria-label="Next page">
						<svg
							width="16"
							height="16"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							aria-hidden="true">
							<polyline points="9 18 15 12 9 6" />
						</svg>
					</button>
					<button
						class="imm-pg-btn imm-pg-btn--nav"
						type="button"
						[disabled]="pageIndex >= totalPages - 1"
						(click)="goToPage(totalPages - 1)"
						aria-label="Last page">
						<svg
							width="16"
							height="16"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							aria-hidden="true">
							<polyline points="5 18 11 12 5 6" />
							<polyline points="13 18 19 12 13 6" />
						</svg>
					</button>
				</div>
			</div>
		</div>
	</div>
</section>
<app-ehe-spinner></app-ehe-spinner>
